import { apiClient } from "./authService";

export interface ProductPayload {
  name: string;
  packageType?: "UNIT" | "PACK";
  salePrice?: number| null;
  costPrice?: number| null;
}

type ProductId = string;

export const fetchProducts = async() => {
  const res = await apiClient.get("/products/list");
  return res.data;
};

export const createProduct = async (payload: ProductPayload) => {
  const res = await apiClient.post("/products/create", payload);
  return res.data;
};

export const updateProduct = async (id: ProductId, payload: Partial<ProductPayload>) => {
  if (!id) throw new Error("Product ID is required.");
  const res = await apiClient.patch(`/products/update/${id}`, payload);
  return res.data;
};

export const deleteProduct = async (id: ProductId) => {
  if (!id) throw new Error("Product ID is required.");
  const res = await apiClient.delete(`/products/delete/${id}`);
  return res.data;
};


// reports for products

export interface ProductSummaryItem {
  productId: string;
  productName: string | null;
  packageType: string | null;
  costPrice: number | null;
  salePrice?: number | null;
  boughtQty: number;
  soldQty: number;
  boughtTotal: number;
  soldTotal: number;
  costTotal: number | null;
  profit: number | null;
}

export interface ProductSummaryParams {
  businessId?: string;
  from?: string;
  to?: string;
}

export const fetchProductSummary = async (params?: ProductSummaryParams) => {
  const res = await apiClient.get("/product-transactions/summary", {
    params: params ?? {},
  });
  return res.data as ProductSummaryItem[];
};

export interface ProductTransactionItem {
  id?: string;
  organizationId?: string;
  businessId?: string | null;
  productId: string;
  direction: "IN" | "OUT";
  qty: number;
  unitPrice?: number | null;
  totalPrice?: number | null;
  sourceType?: string | null;
  sourceId?: string | null;
  sourceDate?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
}

export interface ProductTransactionParams {
  businessId?: string;
  productId?: string;
  direction?: "IN" | "OUT";
  sourceType?: string;
  from?: string;
  to?: string;
  page?: number;
  size?: number;
}

export const fetchProductTransactions = async (
  params?: ProductTransactionParams
) => {
  const res = await apiClient.get("/product-transactions", {
    params: params ?? {},
  });
  return res.data;
};
